module.exports = __webpack_public_path__ + "img/antes_despues_200.0a48a400.png";